import { Button, Textarea } from 'flowbite-react';
import { useState } from 'react';

export type RejectModalProps = {
  onConfirm: (comment: string) => void;
  onCancel: () => void;
};

export const RejectModal = ({ onConfirm, onCancel }: RejectModalProps) => {
  const [comment, setComment] = useState('');
  return (
    <div className="space-y-6">
      <div>
        <p className="text-sm font-medium text-gray-900 mb-2">
          Напишите причину отклонения
        </p>
        <Textarea
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          placeholder="Контрагент Global Finance Inc попал в санкционные списки"
          rows={4}
          className="w-full"
        />
      </div>
      <div className="flex gap-4 border-t border-gray-200 pt-4">
        <Button color="red" onClick={() => onConfirm(comment)}>
          Отклонить
        </Button>
        <Button color="light" onClick={onCancel}>
          Отмена
        </Button>
      </div>
    </div>
  );
};
